export default __webpack_public_path__ + "static/media/by-road.9d13e207.svg";